import React from "react";
import { Icon } from "./Icon.jsx";

export function Avatar({ initials, size = 34, style = {} }) {
  return (
    <span style={{
      flex: "none", display: "flex", alignItems: "center", justifyContent: "center",
      width: size, height: size, borderRadius: "50%",
      background: "linear-gradient(135deg, var(--bg-avatar2), var(--bg-avatar))",
      color: "var(--fg-4c)", fontSize: Math.round(size * 0.38), fontWeight: "var(--fw-semibold)", ...style,
    }}>{initials ? initials : <Icon name="user" size={Math.round(size * 0.53)} />}</span>
  );
}
